export default __webpack_public_path__ + "static/media/logo_itabus.ba8f14d8.svg";